import Vue from 'vue'
import {mapGetters} from 'vuex'

import CitySelect from 'js/components/cities-select/list-layout/city-select'

import template from './index.pug'

export default Vue.extend({
  name: 'city-select-list',

  template: template(),

  components: {
    CitySelect
  },

  computed: {
    ...mapGetters('municipality', ['availableMunicipalities'])
  },

  methods: {
    municipalityClass(index) {
      if (index === 0) {
        return 'end-sm'
      }

      return ''
    }
  }
})
